export default __webpack_public_path__ + "static/media/discord.10c3485c.svg";